import styles from './MediaContainer.module.scss';

function MediaContainer(props: React.PropsWithChildren) {
  return <div className={styles.container} {...props} />;
}

export default MediaContainer;
